"use client";

import { APIProvider } from '@vis.gl/react-google-maps';

interface GoogleMapsProviderProps {
  children: React.ReactNode;
  apiKey: string;
}

export function GoogleMapsProvider({ children, apiKey }: GoogleMapsProviderProps) {
  if (!apiKey) {
    console.error('❌ [GoogleMapsProvider] No API key provided!');
    return <div>Google Maps API key is missing</div>;
  }
  
  return (
    <APIProvider 
      apiKey={apiKey} 
      libraries={['places', 'geometry']}
      solutionChannel='GMP_RentWise_2025'
    >
      {children}
    </APIProvider>
  );
}

// Hook for backward compatibility - now always returns loaded since APIProvider handles it
export function useGoogleMaps() {
  return { isLoaded: true };
} 